import Blue from "~/core";

new Blue({
	name: 'Accordion',
	selector: ".accordion",
	setup(accordion) {
    let trigger = accordion.querySelectorAll('.accordion__item')
    let content = accordion.querySelectorAll('.accordion__content');

		this.$addEvents(content, 'click.stop enter.stop', () => false)
		let config = {
			trigger,
			content
		}
    new this.$toggle(config)
	}
});